<template>
  <closed-card class="cashflow-category-closed-card" :class="cardType"
               :title="`${formatAmount(isIncome ? question.incomeAmount : question.billingAmount)} ₪`"
               :editFunc="() => reopenCard(question)"
               :sub-title="cardSubtitle" />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import moneyUtils from '../../../../../../../../utils/money';

export default {
  name: 'CashflowCategoryClosedCard',
  components: {
    ClosedCard: BaseUI.ClosedCard,
  },
  props: {
    question: Object,
  },
  computed: {
    ...mapGetters('cashflowCategoryActions', ['CASHFLOW_CATEGORIES']),
    isIncome() {
      return !!this.question.incomeAmount;
    },
    questionType() {
      return this.isIncome ? 'הכנסות' : 'הוצאות';
    },
    cardType() {
      if (this.question.cashflowCategory === this.CASHFLOW_CATEGORIES.excluded) {
        return 'disabled';
      }
      if (this.isIncome) {
        return 'success';
      }
      if (this.question.cashflowCategory === this.CASHFLOW_CATEGORIES.fixed) {
        return 'danger';
      }
      return 'warning';
    },
    cardSubtitle() {
      if (this.question.cashflowCategory === this.CASHFLOW_CATEGORIES.fixed) {
        return `עברו ל${this.questionType} הקבועות`;
      } else if (this.question.cashflowCategory === this.CASHFLOW_CATEGORIES.excluded) {
        return 'נמחקו מהתזרים';
      }
      return `נשארו ב${this.questionType} המשתנות`;
    },
  },
  methods: {
    ...mapActions('cashflowCategoryActions', ['reopenQuestion']),
    formatAmount(amount) {
      return moneyUtils.formatAmountWithFraction(amount, 0);
    },
    reopenCard(question) {
      this.reopenQuestion({ transactionId: question.transactionId });
    },
  },
};
</script>

<style lang="scss" scoped>

  .cashflow-category-closed-card {
    margin-bottom: 8px;

    .number {
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/investigations/cashflow-category/cashflow-category/CashflowCategoryClosedCard.vue